import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { useConversion } from "../../common/hooks/use.analytics";
import MedicareInformation from "../../common/components/MedicareInformation";
import useUnlockAccountApi from "../../common/hooks/useUnlockAccountApi";
import { createOrUnlockAccountData } from "../../create-account/createAccountContext";
import { AxiosResponse } from "axios";
import { CreateUnlockAccountResponse } from "../../common/hooks/useCreateAccountApi";

const YourMedicareInformation = () => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const api = useUnlockAccountApi();
    const { data, stepForward } = useContext(createOrUnlockAccountData);
    const { medicareNumber, coverageStartDate, part } = data;
    const conversion = useConversion("unlocked_account", "unlocked_account");

    const [apiResponse, setApiResponse] = useState<AxiosResponse<CreateUnlockAccountResponse> | null>(null);

    const callUnlockAccount = async () => {
        setApiResponse(null);
        const response = await api.step1(medicareNumber, coverageStartDate, part);
        if (!response) {
            return;
        }
        setApiResponse(response);
        setIsLoading(false);

        switch (response.status) {
            case 204:
                stepForward();
                break;
            case 404:
                const notLocked = response?.data?.errors?.some((error: any) =>
                    error.message.includes("user is not locked")
                );
                if (notLocked) {
                    history.push("/login", { showAlreadyUnlockedAlert: true });
                }
                break;
            default:
                break;
        }
    };

    return (
        <MedicareInformation
            title={'unlock_account'}
            conversionName={'unlocked_account'}
            conversion={conversion}
            nextCallback={callUnlockAccount}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            apiResponse={apiResponse}
        />

    );
};

export default YourMedicareInformation;
